import { render, staticRenderFns } from "./IcoSpeakerWave.vue?vue&type=template&id=e3294672"
import script from "./IcoSpeakerWave.vue?vue&type=script&lang=js"
export * from "./IcoSpeakerWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports